import { ADICIONAR_FILTRO_MANUTENCAO_VEICULO } from '../types'

export default function adicionarFiltroManutencaoVeiculo (filtro) {
  return {
    type: ADICIONAR_FILTRO_MANUTENCAO_VEICULO,
    payload: filtro
  }
}
